import React, { FunctionComponent } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import IndicatorsPage from './pages/indicatorsPage';
import IndicatorsDetailPage from './pages/indicatorsDetailPage';
// import indicatorsDetailHistoryPage from './pages/indicatorsDetailHistoryPage';
import NotFoundPage from './pages/notFoundPage';
// import DesignPage from './pages/designPage';
  
const App: FunctionComponent = () => {

    return (
        <Router>    
            <Switch>
                <Route exact path="/" component={IndicatorsPage}/>
                {/* <Route exact path="/design/:uid" component={DesignPage}/> */}
                <Route exact path="/indicators/:uid" component={IndicatorsDetailPage}/>
                <Route exact path="/stats" render={(props) => <IndicatorsPage {...props} activeTab="stats" />}
/>
                <Route component={NotFoundPage} />
            </Switch>
        </Router>
    )
}
  
export default App;